<!-- src/views/public/OurFellows.vue -->
<template>
  <section id="hero" class="hero-section">
    <div class="hero-content">
      <h1>EDCTP Regional Networks of Excellence</h1>
    </div>
  </section>
  <section id="main-content" class="main-content-section">
    <div class="container">
      <div class="content-grid">
        <div class="content-image-wrapper">
          <!--merged image-->
          <div class="image-stack">
            <img src="/702be93291727effdf4416197d3245bc3cbb60c0.jpg" alt="Researchers in a lab" class="main-image">
            <svg xmlns="http://www.w3.org/2000/svg" width="174" height="160" viewBox="0 0 174 160" fill="none">
              <path d="M168 143C168 144.653 169.342 146 171 146C172.658 146 174 144.658 174 143C174 141.342 172.658 140 171 140C169.342 140 168 141.342 168 143Z" fill="#E6F5F7"/>
              <path d="M154 143C154 144.653 155.342 146 157 146C158.658 146 160 144.658 160 143C160 141.342 158.658 140 157 140C155.342 140 154 141.342 154 143Z" fill="#E6F5F7"/>
              <path d="M140 143C140 144.653 141.342 146 143 146C144.658 146 146 144.658 146 143C146 141.342 144.658 140 143 140C141.342 140 140 141.342 140 143Z" fill="#E6F5F7"/>
              <path d="M126 143C126 144.653 127.342 146 129 146C130.658 146 132 144.658 132 143C132 141.342 130.658 140 129 140C127.342 140 126 141.342 126 143Z" fill="#E6F5F7"/>
              <path d="M112 143C112 144.653 113.342 146 115 146C116.658 146 118 144.658 118 143C118 141.342 116.658 140 115 140C113.342 140 112 141.342 112 143Z" fill="#E6F5F7"/>
              <path d="M98 143C98 144.653 99.3417 146 101 146C102.658 146 104 144.658 104 143C104 141.342 102.658 140 101 140C99.3417 140 98 141.342 98 143Z" fill="#E6F5F7"/>
              <path d="M84 143C84 144.653 85.3417 146 87 146C88.6583 146 90 144.658 90 143C90 141.342 88.6583 140 87 140C85.3417 140 84 141.342 84 143Z" fill="#E6F5F7"/>
              <path d="M70 143C70 144.653 71.3417 146 73 146C74.6583 146 76 144.658 76 143C76 141.342 74.6583 140 73 140C71.3417 140 70 141.342 70 143Z" fill="#E6F5F7"/>
              <path d="M56 143C56 144.653 57.3417 146 59 146C60.6583 146 62 144.658 62 143C62 141.342 60.6583 140 59 140C57.3417 140 56 141.342 56 143Z" fill="#E6F5F7"/>
              <path d="M42 143C42 144.653 43.3417 146 45 146C46.6583 146 48 144.658 48 143C48 141.342 46.6583 140 45 140C43.3417 140 42 141.342 42 143Z" fill="#E6F5F7"/>
              <path d="M28 143C28 144.653 29.3417 146 31 146C32.6583 146 34 144.658 34 143C34 141.342 32.6583 140 31 140C29.3417 140 28 141.342 28 143Z" fill="#E6F5F7"/>
              <path d="M14 143C14 144.653 15.3417 146 17 146C18.6583 146 20 144.658 20 143C20 141.342 18.6583 140 17 140C15.3417 140 14 141.342 14 143Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 143C-2.03385e-07 144.653 1.34169 146 3.00001 146C4.65832 146 6 144.658 6 143C6 141.342 4.65832 140 3.00001 140C1.34169 140 -5.86457e-08 141.342 -1.31133e-07 143Z" fill="#E6F5F7"/>
              <path d="M168 157C168 158.653 169.342 160 171 160C172.658 160 174 158.658 174 157C174 155.342 172.658 154 171 154C169.342 154 168 155.342 168 157Z" fill="#E6F5F7"/>
              <path d="M154 157C154 158.653 155.342 160 157 160C158.658 160 160 158.658 160 157C160 155.342 158.658 154 157 154C155.342 154 154 155.342 154 157Z" fill="#E6F5F7"/>
              <path d="M140 157C140 158.653 141.342 160 143 160C144.658 160 146 158.658 146 157C146 155.342 144.658 154 143 154C141.342 154 140 155.342 140 157Z" fill="#E6F5F7"/>
              <path d="M126 157C126 158.653 127.342 160 129 160C130.658 160 132 158.658 132 157C132 155.342 130.658 154 129 154C127.342 154 126 155.342 126 157Z" fill="#E6F5F7"/>
              <path d="M112 157C112 158.653 113.342 160 115 160C116.658 160 118 158.658 118 157C118 155.342 116.658 154 115 154C113.342 154 112 155.342 112 157Z" fill="#E6F5F7"/>
              <path d="M98 157C98 158.653 99.3417 160 101 160C102.658 160 104 158.658 104 157C104 155.342 102.658 154 101 154C99.3417 154 98 155.342 98 157Z" fill="#E6F5F7"/>
              <path d="M84 157C84 158.653 85.3417 160 87 160C88.6583 160 90 158.658 90 157C90 155.342 88.6583 154 87 154C85.3417 154 84 155.342 84 157Z" fill="#E6F5F7"/>
              <path d="M70 157C70 158.653 71.3417 160 73 160C74.6583 160 76 158.658 76 157C76 155.342 74.6583 154 73 154C71.3417 154 70 155.342 70 157Z" fill="#E6F5F7"/>
              <path d="M56 157C56 158.653 57.3417 160 59 160C60.6583 160 62 158.658 62 157C62 155.342 60.6583 154 59 154C57.3417 154 56 155.342 56 157Z" fill="#E6F5F7"/>
              <path d="M42 157C42 158.653 43.3417 160 45 160C46.6583 160 48 158.658 48 157C48 155.342 46.6583 154 45 154C43.3417 154 42 155.342 42 157Z" fill="#E6F5F7"/>
              <path d="M28 157C28 158.653 29.3417 160 31 160C32.6583 160 34 158.658 34 157C34 155.342 32.6583 154 31 154C29.3417 154 28 155.342 28 157Z" fill="#E6F5F7"/>
              <path d="M14 157C14 158.653 15.3417 160 17 160C18.6583 160 20 158.658 20 157C20 155.342 18.6583 154 17 154C15.3417 154 14 155.342 14 157Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 157C-2.03385e-07 158.653 1.34169 160 3.00001 160C4.65832 160 6 158.658 6 157C6 155.342 4.65832 154 3.00001 154C1.34169 154 -5.86457e-08 155.342 -1.31133e-07 157Z" fill="#E6F5F7"/>
              <path d="M168 129C168 130.653 169.342 132 171 132C172.658 132 174 130.658 174 129C174 127.342 172.658 126 171 126C169.342 126 168 127.342 168 129Z" fill="#E6F5F7"/>
              <path d="M154 129C154 130.653 155.342 132 157 132C158.658 132 160 130.658 160 129C160 127.342 158.658 126 157 126C155.342 126 154 127.342 154 129Z" fill="#E6F5F7"/>
              <path d="M140 129C140 130.653 141.342 132 143 132C144.658 132 146 130.658 146 129C146 127.342 144.658 126 143 126C141.342 126 140 127.342 140 129Z" fill="#E6F5F7"/>
              <path d="M126 129C126 130.653 127.342 132 129 132C130.658 132 132 130.658 132 129C132 127.342 130.658 126 129 126C127.342 126 126 127.342 126 129Z" fill="#E6F5F7"/>
              <path d="M112 129C112 130.653 113.342 132 115 132C116.658 132 118 130.658 118 129C118 127.342 116.658 126 115 126C113.342 126 112 127.342 112 129Z" fill="#E6F5F7"/>
              <path d="M98 129C98 130.653 99.3417 132 101 132C102.658 132 104 130.658 104 129C104 127.342 102.658 126 101 126C99.3417 126 98 127.342 98 129Z" fill="#E6F5F7"/>
              <path d="M84 129C84 130.653 85.3417 132 87 132C88.6583 132 90 130.658 90 129C90 127.342 88.6583 126 87 126C85.3417 126 84 127.342 84 129Z" fill="#E6F5F7"/>
              <path d="M70 129C70 130.653 71.3417 132 73 132C74.6583 132 76 130.658 76 129C76 127.342 74.6583 126 73 126C71.3417 126 70 127.342 70 129Z" fill="#E6F5F7"/>
              <path d="M56 129C56 130.653 57.3417 132 59 132C60.6583 132 62 130.658 62 129C62 127.342 60.6583 126 59 126C57.3417 126 56 127.342 56 129Z" fill="#E6F5F7"/>
              <path d="M42 129C42 130.653 43.3417 132 45 132C46.6583 132 48 130.658 48 129C48 127.342 46.6583 126 45 126C43.3417 126 42 127.342 42 129Z" fill="#E6F5F7"/>
              <path d="M28 129C28 130.653 29.3417 132 31 132C32.6583 132 34 130.658 34 129C34 127.342 32.6583 126 31 126C29.3417 126 28 127.342 28 129Z" fill="#E6F5F7"/>
              <path d="M14 129C14 130.653 15.3417 132 17 132C18.6583 132 20 130.658 20 129C20 127.342 18.6583 126 17 126C15.3417 126 14 127.342 14 129Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 129C-2.03385e-07 130.653 1.34169 132 3.00001 132C4.65832 132 6 130.658 6 129C6 127.342 4.65832 126 3.00001 126C1.34169 126 -5.86457e-08 127.342 -1.31133e-07 129Z" fill="#E6F5F7"/>
              <path d="M168 115C168 116.653 169.342 118 171 118C172.658 118 174 116.658 174 115C174 113.342 172.658 112 171 112C169.342 112 168 113.342 168 115Z" fill="#E6F5F7"/>
              <path d="M154 115C154 116.653 155.342 118 157 118C158.658 118 160 116.658 160 115C160 113.342 158.658 112 157 112C155.342 112 154 113.342 154 115Z" fill="#E6F5F7"/>
              <path d="M140 115C140 116.653 141.342 118 143 118C144.658 118 146 116.658 146 115C146 113.342 144.658 112 143 112C141.342 112 140 113.342 140 115Z" fill="#E6F5F7"/>
              <path d="M126 115C126 116.653 127.342 118 129 118C130.658 118 132 116.658 132 115C132 113.342 130.658 112 129 112C127.342 112 126 113.342 126 115Z" fill="#E6F5F7"/>
              <path d="M112 115C112 116.653 113.342 118 115 118C116.658 118 118 116.658 118 115C118 113.342 116.658 112 115 112C113.342 112 112 113.342 112 115Z" fill="#E6F5F7"/>
              <path d="M98 115C98 116.653 99.3417 118 101 118C102.658 118 104 116.658 104 115C104 113.342 102.658 112 101 112C99.3417 112 98 113.342 98 115Z" fill="#E6F5F7"/>
              <path d="M84 115C84 116.653 85.3417 118 87 118C88.6583 118 90 116.658 90 115C90 113.342 88.6583 112 87 112C85.3417 112 84 113.342 84 115Z" fill="#E6F5F7"/>
              <path d="M70 115C70 116.653 71.3417 118 73 118C74.6583 118 76 116.658 76 115C76 113.342 74.6583 112 73 112C71.3417 112 70 113.342 70 115Z" fill="#E6F5F7"/>
              <path d="M56 115C56 116.653 57.3417 118 59 118C60.6583 118 62 116.658 62 115C62 113.342 60.6583 112 59 112C57.3417 112 56 113.342 56 115Z" fill="#E6F5F7"/>
              <path d="M42 115C42 116.653 43.3417 118 45 118C46.6583 118 48 116.658 48 115C48 113.342 46.6583 112 45 112C43.3417 112 42 113.342 42 115Z" fill="#E6F5F7"/>
              <path d="M28 115C28 116.653 29.3417 118 31 118C32.6583 118 34 116.658 34 115C34 113.342 32.6583 112 31 112C29.3417 112 28 113.342 28 115Z" fill="#E6F5F7"/>
              <path d="M14 115C14 116.653 15.3417 118 17 118C18.6583 118 20 116.658 20 115C20 113.342 18.6583 112 17 112C15.3417 112 14 113.342 14 115Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 115C-2.03385e-07 116.653 1.34169 118 3.00001 118C4.65832 118 6 116.658 6 115C6 113.342 4.65832 112 3.00001 112C1.34169 112 -5.86457e-08 113.342 -1.31133e-07 115Z" fill="#E6F5F7"/>
              <path d="M168 101C168 102.653 169.342 104 171 104C172.658 104 174 102.658 174 101C174 99.3417 172.658 98 171 98C169.342 98 168 99.3417 168 101Z" fill="#E6F5F7"/>
              <path d="M168 87C168 88.6529 169.342 90 171 90C172.658 90 174 88.6583 174 87C174 85.3417 172.658 84 171 84C169.342 84 168 85.3417 168 87Z" fill="#E6F5F7"/>
              <path d="M168 73C168 74.6529 169.342 76 171 76C172.658 76 174 74.6583 174 73C174 71.3417 172.658 70 171 70C169.342 70 168 71.3417 168 73Z" fill="#E6F5F7"/>
              <path d="M168 59C168 60.6529 169.342 62 171 62C172.658 62 174 60.6583 174 59C174 57.3417 172.658 56 171 56C169.342 56 168 57.3417 168 59Z" fill="#E6F5F7"/>
              <path d="M168 45C168 46.6529 169.342 48 171 48C172.658 48 174 46.6583 174 45C174 43.3417 172.658 42 171 42C169.342 42 168 43.3417 168 45Z" fill="#E6F5F7"/>
              <path d="M168 31C168 32.6529 169.342 34 171 34C172.658 34 174 32.6583 174 31C174 29.3417 172.658 28 171 28C169.342 28 168 29.3417 168 31Z" fill="#E6F5F7"/>
              <path d="M168 17C168 18.6529 169.342 20 171 20C172.658 20 174 18.6583 174 17C174 15.3417 172.658 14 171 14C169.342 14 168 15.3417 168 17Z" fill="#E6F5F7"/>
              <path d="M168 2.99997C168 4.65291 169.342 6 171 6C172.658 6 174 4.65828 174 2.99997C174 1.34166 172.658 -5.86466e-08 171 -1.31134e-07C169.342 -2.03621e-07 168 1.34166 168 2.99997Z" fill="#E6F5F7"/>
              <path d="M154 101C154 102.653 155.342 104 157 104C158.658 104 160 102.658 160 101C160 99.3417 158.658 98 157 98C155.342 98 154 99.3417 154 101Z" fill="#E6F5F7"/>
              <path d="M154 87C154 88.6529 155.342 90 157 90C158.658 90 160 88.6583 160 87C160 85.3417 158.658 84 157 84C155.342 84 154 85.3417 154 87Z" fill="#E6F5F7"/>
              <path d="M154 73C154 74.6529 155.342 76 157 76C158.658 76 160 74.6583 160 73C160 71.3417 158.658 70 157 70C155.342 70 154 71.3417 154 73Z" fill="#E6F5F7"/>
              <path d="M154 59C154 60.6529 155.342 62 157 62C158.658 62 160 60.6583 160 59C160 57.3417 158.658 56 157 56C155.342 56 154 57.3417 154 59Z" fill="#E6F5F7"/>
              <path d="M154 45C154 46.6529 155.342 48 157 48C158.658 48 160 46.6583 160 45C160 43.3417 158.658 42 157 42C155.342 42 154 43.3417 154 45Z" fill="#E6F5F7"/>
              <path d="M154 31C154 32.6529 155.342 34 157 34C158.658 34 160 32.6583 160 31C160 29.3417 158.658 28 157 28C155.342 28 154 29.3417 154 31Z" fill="#E6F5F7"/>
              <path d="M154 17C154 18.6529 155.342 20 157 20C158.658 20 160 18.6583 160 17C160 15.3417 158.658 14 157 14C155.342 14 154 15.3417 154 17Z" fill="#E6F5F7"/>
              <path d="M154 2.99997C154 4.65291 155.342 6 157 6C158.658 6 160 4.65828 160 2.99997C160 1.34166 158.658 -5.86466e-08 157 -1.31134e-07C155.342 -2.03621e-07 154 1.34166 154 2.99997Z" fill="#E6F5F7"/>
              <path d="M140 101C140 102.653 141.342 104 143 104C144.658 104 146 102.658 146 101C146 99.3417 144.658 98 143 98C141.342 98 140 99.3417 140 101Z" fill="#E6F5F7"/>
              <path d="M140 87C140 88.6529 141.342 90 143 90C144.658 90 146 88.6583 146 87C146 85.3417 144.658 84 143 84C141.342 84 140 85.3417 140 87Z" fill="#E6F5F7"/>
              <path d="M140 73C140 74.6529 141.342 76 143 76C144.658 76 146 74.6583 146 73C146 71.3417 144.658 70 143 70C141.342 70 140 71.3417 140 73Z" fill="#E6F5F7"/>
              <path d="M140 59C140 60.6529 141.342 62 143 62C144.658 62 146 60.6583 146 59C146 57.3417 144.658 56 143 56C141.342 56 140 57.3417 140 59Z" fill="#E6F5F7"/>
              <path d="M140 45C140 46.6529 141.342 48 143 48C144.658 48 146 46.6583 146 45C146 43.3417 144.658 42 143 42C141.342 42 140 43.3417 140 45Z" fill="#E6F5F7"/>
              <path d="M140 31C140 32.6529 141.342 34 143 34C144.658 34 146 32.6583 146 31C146 29.3417 144.658 28 143 28C141.342 28 140 29.3417 140 31Z" fill="#E6F5F7"/>
              <path d="M140 17C140 18.6529 141.342 20 143 20C144.658 20 146 18.6583 146 17C146 15.3417 144.658 14 143 14C141.342 14 140 15.3417 140 17Z" fill="#E6F5F7"/>
              <path d="M140 2.99997C140 4.65291 141.342 6 143 6C144.658 6 146 4.65828 146 2.99997C146 1.34166 144.658 -5.86466e-08 143 -1.31134e-07C141.342 -2.03621e-07 140 1.34166 140 2.99997Z" fill="#E6F5F7"/>
              <path d="M126 101C126 102.653 127.342 104 129 104C130.658 104 132 102.658 132 101C132 99.3417 130.658 98 129 98C127.342 98 126 99.3417 126 101Z" fill="#E6F5F7"/>
              <path d="M126 87C126 88.6529 127.342 90 129 90C130.658 90 132 88.6583 132 87C132 85.3417 130.658 84 129 84C127.342 84 126 85.3417 126 87Z" fill="#E6F5F7"/>
              <path d="M126 73C126 74.6529 127.342 76 129 76C130.658 76 132 74.6583 132 73C132 71.3417 130.658 70 129 70C127.342 70 126 71.3417 126 73Z" fill="#E6F5F7"/>
              <path d="M126 59C126 60.6529 127.342 62 129 62C130.658 62 132 60.6583 132 59C132 57.3417 130.658 56 129 56C127.342 56 126 57.3417 126 59Z" fill="#E6F5F7"/>
              <path d="M126 45C126 46.6529 127.342 48 129 48C130.658 48 132 46.6583 132 45C132 43.3417 130.658 42 129 42C127.342 42 126 43.3417 126 45Z" fill="#E6F5F7"/>
              <path d="M126 31C126 32.6529 127.342 34 129 34C130.658 34 132 32.6583 132 31C132 29.3417 130.658 28 129 28C127.342 28 126 29.3417 126 31Z" fill="#E6F5F7"/>
              <path d="M126 17C126 18.6529 127.342 20 129 20C130.658 20 132 18.6583 132 17C132 15.3417 130.658 14 129 14C127.342 14 126 15.3417 126 17Z" fill="#E6F5F7"/>
              <path d="M126 2.99997C126 4.65291 127.342 6 129 6C130.658 6 132 4.65828 132 2.99997C132 1.34166 130.658 -5.86466e-08 129 -1.31134e-07C127.342 -2.03621e-07 126 1.34166 126 2.99997Z" fill="#E6F5F7"/>
              <path d="M112 101C112 102.653 113.342 104 115 104C116.658 104 118 102.658 118 101C118 99.3417 116.658 98 115 98C113.342 98 112 99.3417 112 101Z" fill="#E6F5F7"/>
              <path d="M112 87C112 88.6529 113.342 90 115 90C116.658 90 118 88.6583 118 87C118 85.3417 116.658 84 115 84C113.342 84 112 85.3417 112 87Z" fill="#E6F5F7"/>
              <path d="M112 73C112 74.6529 113.342 76 115 76C116.658 76 118 74.6583 118 73C118 71.3417 116.658 70 115 70C113.342 70 112 71.3417 112 73Z" fill="#E6F5F7"/>
              <path d="M112 59C112 60.6529 113.342 62 115 62C116.658 62 118 60.6583 118 59C118 57.3417 116.658 56 115 56C113.342 56 112 57.3417 112 59Z" fill="#E6F5F7"/>
              <path d="M112 45C112 46.6529 113.342 48 115 48C116.658 48 118 46.6583 118 45C118 43.3417 116.658 42 115 42C113.342 42 112 43.3417 112 45Z" fill="#E6F5F7"/>
              <path d="M112 31C112 32.6529 113.342 34 115 34C116.658 34 118 32.6583 118 31C118 29.3417 116.658 28 115 28C113.342 28 112 29.3417 112 31Z" fill="#E6F5F7"/>
              <path d="M112 17C112 18.6529 113.342 20 115 20C116.658 20 118 18.6583 118 17C118 15.3417 116.658 14 115 14C113.342 14 112 15.3417 112 17Z" fill="#E6F5F7"/>
              <path d="M112 2.99997C112 4.65291 113.342 6 115 6C116.658 6 118 4.65828 118 2.99997C118 1.34166 116.658 -5.86466e-08 115 -1.31134e-07C113.342 -2.03621e-07 112 1.34166 112 2.99997Z" fill="#E6F5F7"/>
              <path d="M98 101C98 102.653 99.3417 104 101 104C102.658 104 104 102.658 104 101C104 99.3417 102.658 98 101 98C99.3417 98 98 99.3417 98 101Z" fill="#E6F5F7"/>
              <path d="M98 87C98 88.6529 99.3417 90 101 90C102.658 90 104 88.6583 104 87C104 85.3417 102.658 84 101 84C99.3417 84 98 85.3417 98 87Z" fill="#E6F5F7"/>
              <path d="M98 73C98 74.6529 99.3417 76 101 76C102.658 76 104 74.6583 104 73C104 71.3417 102.658 70 101 70C99.3417 70 98 71.3417 98 73Z" fill="#E6F5F7"/>
              <path d="M98 59C98 60.6529 99.3417 62 101 62C102.658 62 104 60.6583 104 59C104 57.3417 102.658 56 101 56C99.3417 56 98 57.3417 98 59Z" fill="#E6F5F7"/>
              <path d="M98 45C98 46.6529 99.3417 48 101 48C102.658 48 104 46.6583 104 45C104 43.3417 102.658 42 101 42C99.3417 42 98 43.3417 98 45Z" fill="#E6F5F7"/>
              <path d="M98 31C98 32.6529 99.3417 34 101 34C102.658 34 104 32.6583 104 31C104 29.3417 102.658 28 101 28C99.3417 28 98 29.3417 98 31Z" fill="#E6F5F7"/>
              <path d="M98 17C98 18.6529 99.3417 20 101 20C102.658 20 104 18.6583 104 17C104 15.3417 102.658 14 101 14C99.3417 14 98 15.3417 98 17Z" fill="#E6F5F7"/>
              <path d="M98 2.99997C98 4.65291 99.3417 6 101 6C102.658 6 104 4.65828 104 2.99997C104 1.34166 102.658 -5.86466e-08 101 -1.31134e-07C99.3417 -2.03621e-07 98 1.34166 98 2.99997Z" fill="#E6F5F7"/>
              <path d="M84 101C84 102.653 85.3417 104 87 104C88.6583 104 90 102.658 90 101C90 99.3417 88.6583 98 87 98C85.3417 98 84 99.3417 84 101Z" fill="#E6F5F7"/>
              <path d="M84 87C84 88.6529 85.3417 90 87 90C88.6583 90 90 88.6583 90 87C90 85.3417 88.6583 84 87 84C85.3417 84 84 85.3417 84 87Z" fill="#E6F5F7"/>
              <path d="M84 73C84 74.6529 85.3417 76 87 76C88.6583 76 90 74.6583 90 73C90 71.3417 88.6583 70 87 70C85.3417 70 84 71.3417 84 73Z" fill="#E6F5F7"/>
              <path d="M84 59C84 60.6529 85.3417 62 87 62C88.6583 62 90 60.6583 90 59C90 57.3417 88.6583 56 87 56C85.3417 56 84 57.3417 84 59Z" fill="#E6F5F7"/>
              <path d="M84 45C84 46.6529 85.3417 48 87 48C88.6583 48 90 46.6583 90 45C90 43.3417 88.6583 42 87 42C85.3417 42 84 43.3417 84 45Z" fill="#E6F5F7"/>
              <path d="M84 31C84 32.6529 85.3417 34 87 34C88.6583 34 90 32.6583 90 31C90 29.3417 88.6583 28 87 28C85.3417 28 84 29.3417 84 31Z" fill="#E6F5F7"/>
              <path d="M84 17C84 18.6529 85.3417 20 87 20C88.6583 20 90 18.6583 90 17C90 15.3417 88.6583 14 87 14C85.3417 14 84 15.3417 84 17Z" fill="#E6F5F7"/>
              <path d="M84 2.99997C84 4.65291 85.3417 6 87 6C88.6583 6 90 4.65828 90 2.99997C90 1.34166 88.6583 -5.86466e-08 87 -1.31134e-07C85.3417 -2.03621e-07 84 1.34166 84 2.99997Z" fill="#E6F5F7"/>
              <path d="M70 101C70 102.653 71.3417 104 73 104C74.6583 104 76 102.658 76 101C76 99.3417 74.6583 98 73 98C71.3417 98 70 99.3417 70 101Z" fill="#E6F5F7"/>
              <path d="M70 87C70 88.6529 71.3417 90 73 90C74.6583 90 76 88.6583 76 87C76 85.3417 74.6583 84 73 84C71.3417 84 70 85.3417 70 87Z" fill="#E6F5F7"/>
              <path d="M70 73C70 74.6529 71.3417 76 73 76C74.6583 76 76 74.6583 76 73C76 71.3417 74.6583 70 73 70C71.3417 70 70 71.3417 70 73Z" fill="#E6F5F7"/>
              <path d="M70 59C70 60.6529 71.3417 62 73 62C74.6583 62 76 60.6583 76 59C76 57.3417 74.6583 56 73 56C71.3417 56 70 57.3417 70 59Z" fill="#E6F5F7"/>
              <path d="M70 45C70 46.6529 71.3417 48 73 48C74.6583 48 76 46.6583 76 45C76 43.3417 74.6583 42 73 42C71.3417 42 70 43.3417 70 45Z" fill="#E6F5F7"/>
              <path d="M70 31C70 32.6529 71.3417 34 73 34C74.6583 34 76 32.6583 76 31C76 29.3417 74.6583 28 73 28C71.3417 28 70 29.3417 70 31Z" fill="#E6F5F7"/>
              <path d="M70 17C70 18.6529 71.3417 20 73 20C74.6583 20 76 18.6583 76 17C76 15.3417 74.6583 14 73 14C71.3417 14 70 15.3417 70 17Z" fill="#E6F5F7"/>
              <path d="M70 2.99997C70 4.65291 71.3417 6 73 6C74.6583 6 76 4.65828 76 2.99997C76 1.34166 74.6583 -5.86466e-08 73 -1.31134e-07C71.3417 -2.03621e-07 70 1.34166 70 2.99997Z" fill="#E6F5F7"/>
              <path d="M56 101C56 102.653 57.3417 104 59 104C60.6583 104 62 102.658 62 101C62 99.3417 60.6583 98 59 98C57.3417 98 56 99.3417 56 101Z" fill="#E6F5F7"/>
              <path d="M56 87C56 88.6529 57.3417 90 59 90C60.6583 90 62 88.6583 62 87C62 85.3417 60.6583 84 59 84C57.3417 84 56 85.3417 56 87Z" fill="#E6F5F7"/>
              <path d="M56 73C56 74.6529 57.3417 76 59 76C60.6583 76 62 74.6583 62 73C62 71.3417 60.6583 70 59 70C57.3417 70 56 71.3417 56 73Z" fill="#E6F5F7"/>
              <path d="M56 59C56 60.6529 57.3417 62 59 62C60.6583 62 62 60.6583 62 59C62 57.3417 60.6583 56 59 56C57.3417 56 56 57.3417 56 59Z" fill="#E6F5F7"/>
              <path d="M56 45C56 46.6529 57.3417 48 59 48C60.6583 48 62 46.6583 62 45C62 43.3417 60.6583 42 59 42C57.3417 42 56 43.3417 56 45Z" fill="#E6F5F7"/>
              <path d="M56 31C56 32.6529 57.3417 34 59 34C60.6583 34 62 32.6583 62 31C62 29.3417 60.6583 28 59 28C57.3417 28 56 29.3417 56 31Z" fill="#E6F5F7"/>
              <path d="M56 17C56 18.6529 57.3417 20 59 20C60.6583 20 62 18.6583 62 17C62 15.3417 60.6583 14 59 14C57.3417 14 56 15.3417 56 17Z" fill="#E6F5F7"/>
              <path d="M56 2.99997C56 4.65291 57.3417 6 59 6C60.6583 6 62 4.65828 62 2.99997C62 1.34166 60.6583 -5.86466e-08 59 -1.31134e-07C57.3417 -2.03621e-07 56 1.34166 56 2.99997Z" fill="#E6F5F7"/>
              <path d="M42 101C42 102.653 43.3417 104 45 104C46.6583 104 48 102.658 48 101C48 99.3417 46.6583 98 45 98C43.3417 98 42 99.3417 42 101Z" fill="#E6F5F7"/>
              <path d="M42 87C42 88.6529 43.3417 90 45 90C46.6583 90 48 88.6583 48 87C48 85.3417 46.6583 84 45 84C43.3417 84 42 85.3417 42 87Z" fill="#E6F5F7"/>
              <path d="M42 73C42 74.6529 43.3417 76 45 76C46.6583 76 48 74.6583 48 73C48 71.3417 46.6583 70 45 70C43.3417 70 42 71.3417 42 73Z" fill="#E6F5F7"/>
              <path d="M42 59C42 60.6529 43.3417 62 45 62C46.6583 62 48 60.6583 48 59C48 57.3417 46.6583 56 45 56C43.3417 56 42 57.3417 42 59Z" fill="#E6F5F7"/>
              <path d="M42 45C42 46.6529 43.3417 48 45 48C46.6583 48 48 46.6583 48 45C48 43.3417 46.6583 42 45 42C43.3417 42 42 43.3417 42 45Z" fill="#E6F5F7"/>
              <path d="M42 31C42 32.6529 43.3417 34 45 34C46.6583 34 48 32.6583 48 31C48 29.3417 46.6583 28 45 28C43.3417 28 42 29.3417 42 31Z" fill="#E6F5F7"/>
              <path d="M42 17C42 18.6529 43.3417 20 45 20C46.6583 20 48 18.6583 48 17C48 15.3417 46.6583 14 45 14C43.3417 14 42 15.3417 42 17Z" fill="#E6F5F7"/>
              <path d="M42 2.99997C42 4.65291 43.3417 6 45 6C46.6583 6 48 4.65828 48 2.99997C48 1.34166 46.6583 -5.86466e-08 45 -1.31134e-07C43.3417 -2.03621e-07 42 1.34166 42 2.99997Z" fill="#E6F5F7"/>
              <path d="M28 101C28 102.653 29.3417 104 31 104C32.6583 104 34 102.658 34 101C34 99.3417 32.6583 98 31 98C29.3417 98 28 99.3417 28 101Z" fill="#E6F5F7"/>
              <path d="M28 87C28 88.6529 29.3417 90 31 90C32.6583 90 34 88.6583 34 87C34 85.3417 32.6583 84 31 84C29.3417 84 28 85.3417 28 87Z" fill="#E6F5F7"/>
              <path d="M28 73C28 74.6529 29.3417 76 31 76C32.6583 76 34 74.6583 34 73C34 71.3417 32.6583 70 31 70C29.3417 70 28 71.3417 28 73Z" fill="#E6F5F7"/>
              <path d="M28 59C28 60.6529 29.3417 62 31 62C32.6583 62 34 60.6583 34 59C34 57.3417 32.6583 56 31 56C29.3417 56 28 57.3417 28 59Z" fill="#E6F5F7"/>
              <path d="M28 45C28 46.6529 29.3417 48 31 48C32.6583 48 34 46.6583 34 45C34 43.3417 32.6583 42 31 42C29.3417 42 28 43.3417 28 45Z" fill="#E6F5F7"/>
              <path d="M28 31C28 32.6529 29.3417 34 31 34C32.6583 34 34 32.6583 34 31C34 29.3417 32.6583 28 31 28C29.3417 28 28 29.3417 28 31Z" fill="#E6F5F7"/>
              <path d="M28 17C28 18.6529 29.3417 20 31 20C32.6583 20 34 18.6583 34 17C34 15.3417 32.6583 14 31 14C29.3417 14 28 15.3417 28 17Z" fill="#E6F5F7"/>
              <path d="M28 2.99997C28 4.65291 29.3417 6 31 6C32.6583 6 34 4.65828 34 2.99997C34 1.34166 32.6583 -5.86466e-08 31 -1.31134e-07C29.3417 -2.03621e-07 28 1.34166 28 2.99997Z" fill="#E6F5F7"/>
              <path d="M14 101C14 102.653 15.3417 104 17 104C18.6583 104 20 102.658 20 101C20 99.3417 18.6583 98 17 98C15.3417 98 14 99.3417 14 101Z" fill="#E6F5F7"/>
              <path d="M14 87C14 88.6529 15.3417 90 17 90C18.6583 90 20 88.6583 20 87C20 85.3417 18.6583 84 17 84C15.3417 84 14 85.3417 14 87Z" fill="#E6F5F7"/>
              <path d="M14 73C14 74.6529 15.3417 76 17 76C18.6583 76 20 74.6583 20 73C20 71.3417 18.6583 70 17 70C15.3417 70 14 71.3417 14 73Z" fill="#E6F5F7"/>
              <path d="M14 59C14 60.6529 15.3417 62 17 62C18.6583 62 20 60.6583 20 59C20 57.3417 18.6583 56 17 56C15.3417 56 14 57.3417 14 59Z" fill="#E6F5F7"/>
              <path d="M14 45C14 46.6529 15.3417 48 17 48C18.6583 48 20 46.6583 20 45C20 43.3417 18.6583 42 17 42C15.3417 42 14 43.3417 14 45Z" fill="#E6F5F7"/>
              <path d="M14 31C14 32.6529 15.3417 34 17 34C18.6583 34 20 32.6583 20 31C20 29.3417 18.6583 28 17 28C15.3417 28 14 29.3417 14 31Z" fill="#E6F5F7"/>
              <path d="M14 17C14 18.6529 15.3417 20 17 20C18.6583 20 20 18.6583 20 17C20 15.3417 18.6583 14 17 14C15.3417 14 14 15.3417 14 17Z" fill="#E6F5F7"/>
              <path d="M14 2.99997C14 4.65291 15.3417 6 17 6C18.6583 6 20 4.65828 20 2.99997C20 1.34166 18.6583 -5.86466e-08 17 -1.31134e-07C15.3417 -2.03621e-07 14 1.34166 14 2.99997Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 101C-2.03385e-07 102.653 1.34169 104 3.00001 104C4.65832 104 6 102.658 6 101C6 99.3417 4.65832 98 3.00001 98C1.34169 98 -5.86457e-08 99.3417 -1.31133e-07 101Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 87C-2.03385e-07 88.6529 1.34169 90 3.00001 90C4.65832 90 6 88.6583 6 87C6 85.3417 4.65832 84 3.00001 84C1.34169 84 -5.86457e-08 85.3417 -1.31133e-07 87Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 73C-2.03385e-07 74.6529 1.34169 76 3.00001 76C4.65832 76 6 74.6583 6 73C6 71.3417 4.65832 70 3.00001 70C1.34169 70 -5.86457e-08 71.3417 -1.31133e-07 73Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 59C-2.03385e-07 60.6529 1.34169 62 3.00001 62C4.65832 62 6 60.6583 6 59C6 57.3417 4.65832 56 3.00001 56C1.34169 56 -5.86457e-08 57.3417 -1.31133e-07 59Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 45C-2.03385e-07 46.6529 1.34169 48 3.00001 48C4.65832 48 6 46.6583 6 45C6 43.3417 4.65832 42 3.00001 42C1.34169 42 -5.86457e-08 43.3417 -1.31133e-07 45Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 31C-2.03385e-07 32.6529 1.34169 34 3.00001 34C4.65832 34 6 32.6583 6 31C6 29.3417 4.65832 28 3.00001 28C1.34169 28 -5.86457e-08 29.3417 -1.31133e-07 31Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 17C-2.03385e-07 18.6529 1.34169 20 3.00001 20C4.65832 20 6 18.6583 6 17C6 15.3417 4.65832 14 3.00001 14C1.34169 14 -5.86457e-08 15.3417 -1.31133e-07 17Z" fill="#E6F5F7"/>
              <path d="M-1.31133e-07 2.99997C-2.03385e-07 4.65291 1.34169 6 3.00001 6C4.65832 6 6 4.65828 6 2.99997C6 1.34166 4.65832 -5.86466e-08 3.00001 -1.31134e-07C1.34169 -2.03621e-07 -5.86457e-08 1.34166 -1.31133e-07 2.99997Z" fill="#E6F5F7"/>
            </svg>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" width="174" height="160" viewBox="0 0 174 160" fill="none">
            <path d="M168 143C168 144.653 169.342 146 171 146C172.658 146 174 144.658 174 143C174 141.342 172.658 140 171 140C169.342 140 168 141.342 168 143Z" fill="#E6F5F7"/>
            <path d="M154 143C154 144.653 155.342 146 157 146C158.658 146 160 144.658 160 143C160 141.342 158.658 140 157 140C155.342 140 154 141.342 154 143Z" fill="#E6F5F7"/>
            <path d="M140 143C140 144.653 141.342 146 143 146C144.658 146 146 144.658 146 143C146 141.342 144.658 140 143 140C141.342 140 140 141.342 140 143Z" fill="#E6F5F7"/>
            <path d="M126 143C126 144.653 127.342 146 129 146C130.658 146 132 144.658 132 143C132 141.342 130.658 140 129 140C127.342 140 126 141.342 126 143Z" fill="#E6F5F7"/>
            <path d="M112 143C112 144.653 113.342 146 115 146C116.658 146 118 144.658 118 143C118 141.342 116.658 140 115 140C113.342 140 112 141.342 112 143Z" fill="#E6F5F7"/>
            <path d="M98 143C98 144.653 99.3417 146 101 146C102.658 146 104 144.658 104 143C104 141.342 102.658 140 101 140C99.3417 140 98 141.342 98 143Z" fill="#E6F5F7"/>
            <path d="M84 143C84 144.653 85.3417 146 87 146C88.6583 146 90 144.658 90 143C90 141.342 88.6583 140 87 140C85.3417 140 84 141.342 84 143Z" fill="#E6F5F7"/>
            <path d="M70 143C70 144.653 71.3417 146 73 146C74.6583 146 76 144.658 76 143C76 141.342 74.6583 140 73 140C71.3417 140 70 141.342 70 143Z" fill="#E6F5F7"/>
            <path d="M56 143C56 144.653 57.3417 146 59 146C60.6583 146 62 144.658 62 143C62 141.342 60.6583 140 59 140C57.3417 140 56 141.342 56 143Z" fill="#E6F5F7"/>
            <path d="M42 143C42 144.653 43.3417 146 45 146C46.6583 146 48 144.658 48 143C48 141.342 46.6583 140 45 140C43.3417 140 42 141.342 42 143Z" fill="#E6F5F7"/>
            <path d="M28 143C28 144.653 29.3417 146 31 146C32.6583 146 34 144.658 34 143C34 141.342 32.6583 140 31 140C29.3417 140 28 141.342 28 143Z" fill="#E6F5F7"/>
            <path d="M14 143C14 144.653 15.3417 146 17 146C18.6583 146 20 144.658 20 143C20 141.342 18.6583 140 17 140C15.3417 140 14 141.342 14 143Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 143C-2.03385e-07 144.653 1.34169 146 3.00001 146C4.65832 146 6 144.658 6 143C6 141.342 4.65832 140 3.00001 140C1.34169 140 -5.86457e-08 141.342 -1.31133e-07 143Z" fill="#E6F5F7"/>
            <path d="M168 157C168 158.653 169.342 160 171 160C172.658 160 174 158.658 174 157C174 155.342 172.658 154 171 154C169.342 154 168 155.342 168 157Z" fill="#E6F5F7"/>
            <path d="M154 157C154 158.653 155.342 160 157 160C158.658 160 160 158.658 160 157C160 155.342 158.658 154 157 154C155.342 154 154 155.342 154 157Z" fill="#E6F5F7"/>
            <path d="M140 157C140 158.653 141.342 160 143 160C144.658 160 146 158.658 146 157C146 155.342 144.658 154 143 154C141.342 154 140 155.342 140 157Z" fill="#E6F5F7"/>
            <path d="M126 157C126 158.653 127.342 160 129 160C130.658 160 132 158.658 132 157C132 155.342 130.658 154 129 154C127.342 154 126 155.342 126 157Z" fill="#E6F5F7"/>
            <path d="M112 157C112 158.653 113.342 160 115 160C116.658 160 118 158.658 118 157C118 155.342 116.658 154 115 154C113.342 154 112 155.342 112 157Z" fill="#E6F5F7"/>
            <path d="M98 157C98 158.653 99.3417 160 101 160C102.658 160 104 158.658 104 157C104 155.342 102.658 154 101 154C99.3417 154 98 155.342 98 157Z" fill="#E6F5F7"/>
            <path d="M84 157C84 158.653 85.3417 160 87 160C88.6583 160 90 158.658 90 157C90 155.342 88.6583 154 87 154C85.3417 154 84 155.342 84 157Z" fill="#E6F5F7"/>
            <path d="M70 157C70 158.653 71.3417 160 73 160C74.6583 160 76 158.658 76 157C76 155.342 74.6583 154 73 154C71.3417 154 70 155.342 70 157Z" fill="#E6F5F7"/>
            <path d="M56 157C56 158.653 57.3417 160 59 160C60.6583 160 62 158.658 62 157C62 155.342 60.6583 154 59 154C57.3417 154 56 155.342 56 157Z" fill="#E6F5F7"/>
            <path d="M42 157C42 158.653 43.3417 160 45 160C46.6583 160 48 158.658 48 157C48 155.342 46.6583 154 45 154C43.3417 154 42 155.342 42 157Z" fill="#E6F5F7"/>
            <path d="M28 157C28 158.653 29.3417 160 31 160C32.6583 160 34 158.658 34 157C34 155.342 32.6583 154 31 154C29.3417 154 28 155.342 28 157Z" fill="#E6F5F7"/>
            <path d="M14 157C14 158.653 15.3417 160 17 160C18.6583 160 20 158.658 20 157C20 155.342 18.6583 154 17 154C15.3417 154 14 155.342 14 157Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 157C-2.03385e-07 158.653 1.34169 160 3.00001 160C4.65832 160 6 158.658 6 157C6 155.342 4.65832 154 3.00001 154C1.34169 154 -5.86457e-08 155.342 -1.31133e-07 157Z" fill="#E6F5F7"/>
            <path d="M168 129C168 130.653 169.342 132 171 132C172.658 132 174 130.658 174 129C174 127.342 172.658 126 171 126C169.342 126 168 127.342 168 129Z" fill="#E6F5F7"/>
            <path d="M154 129C154 130.653 155.342 132 157 132C158.658 132 160 130.658 160 129C160 127.342 158.658 126 157 126C155.342 126 154 127.342 154 129Z" fill="#E6F5F7"/>
            <path d="M140 129C140 130.653 141.342 132 143 132C144.658 132 146 130.658 146 129C146 127.342 144.658 126 143 126C141.342 126 140 127.342 140 129Z" fill="#E6F5F7"/>
            <path d="M126 129C126 130.653 127.342 132 129 132C130.658 132 132 130.658 132 129C132 127.342 130.658 126 129 126C127.342 126 126 127.342 126 129Z" fill="#E6F5F7"/>
            <path d="M112 129C112 130.653 113.342 132 115 132C116.658 132 118 130.658 118 129C118 127.342 116.658 126 115 126C113.342 126 112 127.342 112 129Z" fill="#E6F5F7"/>
            <path d="M98 129C98 130.653 99.3417 132 101 132C102.658 132 104 130.658 104 129C104 127.342 102.658 126 101 126C99.3417 126 98 127.342 98 129Z" fill="#E6F5F7"/>
            <path d="M84 129C84 130.653 85.3417 132 87 132C88.6583 132 90 130.658 90 129C90 127.342 88.6583 126 87 126C85.3417 126 84 127.342 84 129Z" fill="#E6F5F7"/>
            <path d="M70 129C70 130.653 71.3417 132 73 132C74.6583 132 76 130.658 76 129C76 127.342 74.6583 126 73 126C71.3417 126 70 127.342 70 129Z" fill="#E6F5F7"/>
            <path d="M56 129C56 130.653 57.3417 132 59 132C60.6583 132 62 130.658 62 129C62 127.342 60.6583 126 59 126C57.3417 126 56 127.342 56 129Z" fill="#E6F5F7"/>
            <path d="M42 129C42 130.653 43.3417 132 45 132C46.6583 132 48 130.658 48 129C48 127.342 46.6583 126 45 126C43.3417 126 42 127.342 42 129Z" fill="#E6F5F7"/>
            <path d="M28 129C28 130.653 29.3417 132 31 132C32.6583 132 34 130.658 34 129C34 127.342 32.6583 126 31 126C29.3417 126 28 127.342 28 129Z" fill="#E6F5F7"/>
            <path d="M14 129C14 130.653 15.3417 132 17 132C18.6583 132 20 130.658 20 129C20 127.342 18.6583 126 17 126C15.3417 126 14 127.342 14 129Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 129C-2.03385e-07 130.653 1.34169 132 3.00001 132C4.65832 132 6 130.658 6 129C6 127.342 4.65832 126 3.00001 126C1.34169 126 -5.86457e-08 127.342 -1.31133e-07 129Z" fill="#E6F5F7"/>
            <path d="M168 115C168 116.653 169.342 118 171 118C172.658 118 174 116.658 174 115C174 113.342 172.658 112 171 112C169.342 112 168 113.342 168 115Z" fill="#E6F5F7"/>
            <path d="M154 115C154 116.653 155.342 118 157 118C158.658 118 160 116.658 160 115C160 113.342 158.658 112 157 112C155.342 112 154 113.342 154 115Z" fill="#E6F5F7"/>
            <path d="M140 115C140 116.653 141.342 118 143 118C144.658 118 146 116.658 146 115C146 113.342 144.658 112 143 112C141.342 112 140 113.342 140 115Z" fill="#E6F5F7"/>
            <path d="M126 115C126 116.653 127.342 118 129 118C130.658 118 132 116.658 132 115C132 113.342 130.658 112 129 112C127.342 112 126 113.342 126 115Z" fill="#E6F5F7"/>
            <path d="M112 115C112 116.653 113.342 118 115 118C116.658 118 118 116.658 118 115C118 113.342 116.658 112 115 112C113.342 112 112 113.342 112 115Z" fill="#E6F5F7"/>
            <path d="M98 115C98 116.653 99.3417 118 101 118C102.658 118 104 116.658 104 115C104 113.342 102.658 112 101 112C99.3417 112 98 113.342 98 115Z" fill="#E6F5F7"/>
            <path d="M84 115C84 116.653 85.3417 118 87 118C88.6583 118 90 116.658 90 115C90 113.342 88.6583 112 87 112C85.3417 112 84 113.342 84 115Z" fill="#E6F5F7"/>
            <path d="M70 115C70 116.653 71.3417 118 73 118C74.6583 118 76 116.658 76 115C76 113.342 74.6583 112 73 112C71.3417 112 70 113.342 70 115Z" fill="#E6F5F7"/>
            <path d="M56 115C56 116.653 57.3417 118 59 118C60.6583 118 62 116.658 62 115C62 113.342 60.6583 112 59 112C57.3417 112 56 113.342 56 115Z" fill="#E6F5F7"/>
            <path d="M42 115C42 116.653 43.3417 118 45 118C46.6583 118 48 116.658 48 115C48 113.342 46.6583 112 45 112C43.3417 112 42 113.342 42 115Z" fill="#E6F5F7"/>
            <path d="M28 115C28 116.653 29.3417 118 31 118C32.6583 118 34 116.658 34 115C34 113.342 32.6583 112 31 112C29.3417 112 28 113.342 28 115Z" fill="#E6F5F7"/>
            <path d="M14 115C14 116.653 15.3417 118 17 118C18.6583 118 20 116.658 20 115C20 113.342 18.6583 112 17 112C15.3417 112 14 113.342 14 115Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 115C-2.03385e-07 116.653 1.34169 118 3.00001 118C4.65832 118 6 116.658 6 115C6 113.342 4.65832 112 3.00001 112C1.34169 112 -5.86457e-08 113.342 -1.31133e-07 115Z" fill="#E6F5F7"/>
            <path d="M168 101C168 102.653 169.342 104 171 104C172.658 104 174 102.658 174 101C174 99.3417 172.658 98 171 98C169.342 98 168 99.3417 168 101Z" fill="#E6F5F7"/>
            <path d="M168 87C168 88.6529 169.342 90 171 90C172.658 90 174 88.6583 174 87C174 85.3417 172.658 84 171 84C169.342 84 168 85.3417 168 87Z" fill="#E6F5F7"/>
            <path d="M168 73C168 74.6529 169.342 76 171 76C172.658 76 174 74.6583 174 73C174 71.3417 172.658 70 171 70C169.342 70 168 71.3417 168 73Z" fill="#E6F5F7"/>
            <path d="M168 59C168 60.6529 169.342 62 171 62C172.658 62 174 60.6583 174 59C174 57.3417 172.658 56 171 56C169.342 56 168 57.3417 168 59Z" fill="#E6F5F7"/>
            <path d="M168 45C168 46.6529 169.342 48 171 48C172.658 48 174 46.6583 174 45C174 43.3417 172.658 42 171 42C169.342 42 168 43.3417 168 45Z" fill="#E6F5F7"/>
            <path d="M168 31C168 32.6529 169.342 34 171 34C172.658 34 174 32.6583 174 31C174 29.3417 172.658 28 171 28C169.342 28 168 29.3417 168 31Z" fill="#E6F5F7"/>
            <path d="M168 17C168 18.6529 169.342 20 171 20C172.658 20 174 18.6583 174 17C174 15.3417 172.658 14 171 14C169.342 14 168 15.3417 168 17Z" fill="#E6F5F7"/>
            <path d="M168 2.99997C168 4.65291 169.342 6 171 6C172.658 6 174 4.65828 174 2.99997C174 1.34166 172.658 -5.86466e-08 171 -1.31134e-07C169.342 -2.03621e-07 168 1.34166 168 2.99997Z" fill="#E6F5F7"/>
            <path d="M154 101C154 102.653 155.342 104 157 104C158.658 104 160 102.658 160 101C160 99.3417 158.658 98 157 98C155.342 98 154 99.3417 154 101Z" fill="#E6F5F7"/>
            <path d="M154 87C154 88.6529 155.342 90 157 90C158.658 90 160 88.6583 160 87C160 85.3417 158.658 84 157 84C155.342 84 154 85.3417 154 87Z" fill="#E6F5F7"/>
            <path d="M154 73C154 74.6529 155.342 76 157 76C158.658 76 160 74.6583 160 73C160 71.3417 158.658 70 157 70C155.342 70 154 71.3417 154 73Z" fill="#E6F5F7"/>
            <path d="M154 59C154 60.6529 155.342 62 157 62C158.658 62 160 60.6583 160 59C160 57.3417 158.658 56 157 56C155.342 56 154 57.3417 154 59Z" fill="#E6F5F7"/>
            <path d="M154 45C154 46.6529 155.342 48 157 48C158.658 48 160 46.6583 160 45C160 43.3417 158.658 42 157 42C155.342 42 154 43.3417 154 45Z" fill="#E6F5F7"/>
            <path d="M154 31C154 32.6529 155.342 34 157 34C158.658 34 160 32.6583 160 31C160 29.3417 158.658 28 157 28C155.342 28 154 29.3417 154 31Z" fill="#E6F5F7"/>
            <path d="M154 17C154 18.6529 155.342 20 157 20C158.658 20 160 18.6583 160 17C160 15.3417 158.658 14 157 14C155.342 14 154 15.3417 154 17Z" fill="#E6F5F7"/>
            <path d="M154 2.99997C154 4.65291 155.342 6 157 6C158.658 6 160 4.65828 160 2.99997C160 1.34166 158.658 -5.86466e-08 157 -1.31134e-07C155.342 -2.03621e-07 154 1.34166 154 2.99997Z" fill="#E6F5F7"/>
            <path d="M140 101C140 102.653 141.342 104 143 104C144.658 104 146 102.658 146 101C146 99.3417 144.658 98 143 98C141.342 98 140 99.3417 140 101Z" fill="#E6F5F7"/>
            <path d="M140 87C140 88.6529 141.342 90 143 90C144.658 90 146 88.6583 146 87C146 85.3417 144.658 84 143 84C141.342 84 140 85.3417 140 87Z" fill="#E6F5F7"/>
            <path d="M140 73C140 74.6529 141.342 76 143 76C144.658 76 146 74.6583 146 73C146 71.3417 144.658 70 143 70C141.342 70 140 71.3417 140 73Z" fill="#E6F5F7"/>
            <path d="M140 59C140 60.6529 141.342 62 143 62C144.658 62 146 60.6583 146 59C146 57.3417 144.658 56 143 56C141.342 56 140 57.3417 140 59Z" fill="#E6F5F7"/>
            <path d="M140 45C140 46.6529 141.342 48 143 48C144.658 48 146 46.6583 146 45C146 43.3417 144.658 42 143 42C141.342 42 140 43.3417 140 45Z" fill="#E6F5F7"/>
            <path d="M140 31C140 32.6529 141.342 34 143 34C144.658 34 146 32.6583 146 31C146 29.3417 144.658 28 143 28C141.342 28 140 29.3417 140 31Z" fill="#E6F5F7"/>
            <path d="M140 17C140 18.6529 141.342 20 143 20C144.658 20 146 18.6583 146 17C146 15.3417 144.658 14 143 14C141.342 14 140 15.3417 140 17Z" fill="#E6F5F7"/>
            <path d="M140 2.99997C140 4.65291 141.342 6 143 6C144.658 6 146 4.65828 146 2.99997C146 1.34166 144.658 -5.86466e-08 143 -1.31134e-07C141.342 -2.03621e-07 140 1.34166 140 2.99997Z" fill="#E6F5F7"/>
            <path d="M126 101C126 102.653 127.342 104 129 104C130.658 104 132 102.658 132 101C132 99.3417 130.658 98 129 98C127.342 98 126 99.3417 126 101Z" fill="#E6F5F7"/>
            <path d="M126 87C126 88.6529 127.342 90 129 90C130.658 90 132 88.6583 132 87C132 85.3417 130.658 84 129 84C127.342 84 126 85.3417 126 87Z" fill="#E6F5F7"/>
            <path d="M126 73C126 74.6529 127.342 76 129 76C130.658 76 132 74.6583 132 73C132 71.3417 130.658 70 129 70C127.342 70 126 71.3417 126 73Z" fill="#E6F5F7"/>
            <path d="M126 59C126 60.6529 127.342 62 129 62C130.658 62 132 60.6583 132 59C132 57.3417 130.658 56 129 56C127.342 56 126 57.3417 126 59Z" fill="#E6F5F7"/>
            <path d="M126 45C126 46.6529 127.342 48 129 48C130.658 48 132 46.6583 132 45C132 43.3417 130.658 42 129 42C127.342 42 126 43.3417 126 45Z" fill="#E6F5F7"/>
            <path d="M126 31C126 32.6529 127.342 34 129 34C130.658 34 132 32.6583 132 31C132 29.3417 130.658 28 129 28C127.342 28 126 29.3417 126 31Z" fill="#E6F5F7"/>
            <path d="M126 17C126 18.6529 127.342 20 129 20C130.658 20 132 18.6583 132 17C132 15.3417 130.658 14 129 14C127.342 14 126 15.3417 126 17Z" fill="#E6F5F7"/>
            <path d="M126 2.99997C126 4.65291 127.342 6 129 6C130.658 6 132 4.65828 132 2.99997C132 1.34166 130.658 -5.86466e-08 129 -1.31134e-07C127.342 -2.03621e-07 126 1.34166 126 2.99997Z" fill="#E6F5F7"/>
            <path d="M112 101C112 102.653 113.342 104 115 104C116.658 104 118 102.658 118 101C118 99.3417 116.658 98 115 98C113.342 98 112 99.3417 112 101Z" fill="#E6F5F7"/>
            <path d="M112 87C112 88.6529 113.342 90 115 90C116.658 90 118 88.6583 118 87C118 85.3417 116.658 84 115 84C113.342 84 112 85.3417 112 87Z" fill="#E6F5F7"/>
            <path d="M112 73C112 74.6529 113.342 76 115 76C116.658 76 118 74.6583 118 73C118 71.3417 116.658 70 115 70C113.342 70 112 71.3417 112 73Z" fill="#E6F5F7"/>
            <path d="M112 59C112 60.6529 113.342 62 115 62C116.658 62 118 60.6583 118 59C118 57.3417 116.658 56 115 56C113.342 56 112 57.3417 112 59Z" fill="#E6F5F7"/>
            <path d="M112 45C112 46.6529 113.342 48 115 48C116.658 48 118 46.6583 118 45C118 43.3417 116.658 42 115 42C113.342 42 112 43.3417 112 45Z" fill="#E6F5F7"/>
            <path d="M112 31C112 32.6529 113.342 34 115 34C116.658 34 118 32.6583 118 31C118 29.3417 116.658 28 115 28C113.342 28 112 29.3417 112 31Z" fill="#E6F5F7"/>
            <path d="M112 17C112 18.6529 113.342 20 115 20C116.658 20 118 18.6583 118 17C118 15.3417 116.658 14 115 14C113.342 14 112 15.3417 112 17Z" fill="#E6F5F7"/>
            <path d="M112 2.99997C112 4.65291 113.342 6 115 6C116.658 6 118 4.65828 118 2.99997C118 1.34166 116.658 -5.86466e-08 115 -1.31134e-07C113.342 -2.03621e-07 112 1.34166 112 2.99997Z" fill="#E6F5F7"/>
            <path d="M98 101C98 102.653 99.3417 104 101 104C102.658 104 104 102.658 104 101C104 99.3417 102.658 98 101 98C99.3417 98 98 99.3417 98 101Z" fill="#E6F5F7"/>
            <path d="M98 87C98 88.6529 99.3417 90 101 90C102.658 90 104 88.6583 104 87C104 85.3417 102.658 84 101 84C99.3417 84 98 85.3417 98 87Z" fill="#E6F5F7"/>
            <path d="M98 73C98 74.6529 99.3417 76 101 76C102.658 76 104 74.6583 104 73C104 71.3417 102.658 70 101 70C99.3417 70 98 71.3417 98 73Z" fill="#E6F5F7"/>
            <path d="M98 59C98 60.6529 99.3417 62 101 62C102.658 62 104 60.6583 104 59C104 57.3417 102.658 56 101 56C99.3417 56 98 57.3417 98 59Z" fill="#E6F5F7"/>
            <path d="M98 45C98 46.6529 99.3417 48 101 48C102.658 48 104 46.6583 104 45C104 43.3417 102.658 42 101 42C99.3417 42 98 43.3417 98 45Z" fill="#E6F5F7"/>
            <path d="M98 31C98 32.6529 99.3417 34 101 34C102.658 34 104 32.6583 104 31C104 29.3417 102.658 28 101 28C99.3417 28 98 29.3417 98 31Z" fill="#E6F5F7"/>
            <path d="M98 17C98 18.6529 99.3417 20 101 20C102.658 20 104 18.6583 104 17C104 15.3417 102.658 14 101 14C99.3417 14 98 15.3417 98 17Z" fill="#E6F5F7"/>
            <path d="M98 2.99997C98 4.65291 99.3417 6 101 6C102.658 6 104 4.65828 104 2.99997C104 1.34166 102.658 -5.86466e-08 101 -1.31134e-07C99.3417 -2.03621e-07 98 1.34166 98 2.99997Z" fill="#E6F5F7"/>
            <path d="M84 101C84 102.653 85.3417 104 87 104C88.6583 104 90 102.658 90 101C90 99.3417 88.6583 98 87 98C85.3417 98 84 99.3417 84 101Z" fill="#E6F5F7"/>
            <path d="M84 87C84 88.6529 85.3417 90 87 90C88.6583 90 90 88.6583 90 87C90 85.3417 88.6583 84 87 84C85.3417 84 84 85.3417 84 87Z" fill="#E6F5F7"/>
            <path d="M84 73C84 74.6529 85.3417 76 87 76C88.6583 76 90 74.6583 90 73C90 71.3417 88.6583 70 87 70C85.3417 70 84 71.3417 84 73Z" fill="#E6F5F7"/>
            <path d="M84 59C84 60.6529 85.3417 62 87 62C88.6583 62 90 60.6583 90 59C90 57.3417 88.6583 56 87 56C85.3417 56 84 57.3417 84 59Z" fill="#E6F5F7"/>
            <path d="M84 45C84 46.6529 85.3417 48 87 48C88.6583 48 90 46.6583 90 45C90 43.3417 88.6583 42 87 42C85.3417 42 84 43.3417 84 45Z" fill="#E6F5F7"/>
            <path d="M84 31C84 32.6529 85.3417 34 87 34C88.6583 34 90 32.6583 90 31C90 29.3417 88.6583 28 87 28C85.3417 28 84 29.3417 84 31Z" fill="#E6F5F7"/>
            <path d="M84 17C84 18.6529 85.3417 20 87 20C88.6583 20 90 18.6583 90 17C90 15.3417 88.6583 14 87 14C85.3417 14 84 15.3417 84 17Z" fill="#E6F5F7"/>
            <path d="M84 2.99997C84 4.65291 85.3417 6 87 6C88.6583 6 90 4.65828 90 2.99997C90 1.34166 88.6583 -5.86466e-08 87 -1.31134e-07C85.3417 -2.03621e-07 84 1.34166 84 2.99997Z" fill="#E6F5F7"/>
            <path d="M70 101C70 102.653 71.3417 104 73 104C74.6583 104 76 102.658 76 101C76 99.3417 74.6583 98 73 98C71.3417 98 70 99.3417 70 101Z" fill="#E6F5F7"/>
            <path d="M70 87C70 88.6529 71.3417 90 73 90C74.6583 90 76 88.6583 76 87C76 85.3417 74.6583 84 73 84C71.3417 84 70 85.3417 70 87Z" fill="#E6F5F7"/>
            <path d="M70 73C70 74.6529 71.3417 76 73 76C74.6583 76 76 74.6583 76 73C76 71.3417 74.6583 70 73 70C71.3417 70 70 71.3417 70 73Z" fill="#E6F5F7"/>
            <path d="M70 59C70 60.6529 71.3417 62 73 62C74.6583 62 76 60.6583 76 59C76 57.3417 74.6583 56 73 56C71.3417 56 70 57.3417 70 59Z" fill="#E6F5F7"/>
            <path d="M70 45C70 46.6529 71.3417 48 73 48C74.6583 48 76 46.6583 76 45C76 43.3417 74.6583 42 73 42C71.3417 42 70 43.3417 70 45Z" fill="#E6F5F7"/>
            <path d="M70 31C70 32.6529 71.3417 34 73 34C74.6583 34 76 32.6583 76 31C76 29.3417 74.6583 28 73 28C71.3417 28 70 29.3417 70 31Z" fill="#E6F5F7"/>
            <path d="M70 17C70 18.6529 71.3417 20 73 20C74.6583 20 76 18.6583 76 17C76 15.3417 74.6583 14 73 14C71.3417 14 70 15.3417 70 17Z" fill="#E6F5F7"/>
            <path d="M70 2.99997C70 4.65291 71.3417 6 73 6C74.6583 6 76 4.65828 76 2.99997C76 1.34166 74.6583 -5.86466e-08 73 -1.31134e-07C71.3417 -2.03621e-07 70 1.34166 70 2.99997Z" fill="#E6F5F7"/>
            <path d="M56 101C56 102.653 57.3417 104 59 104C60.6583 104 62 102.658 62 101C62 99.3417 60.6583 98 59 98C57.3417 98 56 99.3417 56 101Z" fill="#E6F5F7"/>
            <path d="M56 87C56 88.6529 57.3417 90 59 90C60.6583 90 62 88.6583 62 87C62 85.3417 60.6583 84 59 84C57.3417 84 56 85.3417 56 87Z" fill="#E6F5F7"/>
            <path d="M56 73C56 74.6529 57.3417 76 59 76C60.6583 76 62 74.6583 62 73C62 71.3417 60.6583 70 59 70C57.3417 70 56 71.3417 56 73Z" fill="#E6F5F7"/>
            <path d="M56 59C56 60.6529 57.3417 62 59 62C60.6583 62 62 60.6583 62 59C62 57.3417 60.6583 56 59 56C57.3417 56 56 57.3417 56 59Z" fill="#E6F5F7"/>
            <path d="M56 45C56 46.6529 57.3417 48 59 48C60.6583 48 62 46.6583 62 45C62 43.3417 60.6583 42 59 42C57.3417 42 56 43.3417 56 45Z" fill="#E6F5F7"/>
            <path d="M56 31C56 32.6529 57.3417 34 59 34C60.6583 34 62 32.6583 62 31C62 29.3417 60.6583 28 59 28C57.3417 28 56 29.3417 56 31Z" fill="#E6F5F7"/>
            <path d="M56 17C56 18.6529 57.3417 20 59 20C60.6583 20 62 18.6583 62 17C62 15.3417 60.6583 14 59 14C57.3417 14 56 15.3417 56 17Z" fill="#E6F5F7"/>
            <path d="M56 2.99997C56 4.65291 57.3417 6 59 6C60.6583 6 62 4.65828 62 2.99997C62 1.34166 60.6583 -5.86466e-08 59 -1.31134e-07C57.3417 -2.03621e-07 56 1.34166 56 2.99997Z" fill="#E6F5F7"/>
            <path d="M42 101C42 102.653 43.3417 104 45 104C46.6583 104 48 102.658 48 101C48 99.3417 46.6583 98 45 98C43.3417 98 42 99.3417 42 101Z" fill="#E6F5F7"/>
            <path d="M42 87C42 88.6529 43.3417 90 45 90C46.6583 90 48 88.6583 48 87C48 85.3417 46.6583 84 45 84C43.3417 84 42 85.3417 42 87Z" fill="#E6F5F7"/>
            <path d="M42 73C42 74.6529 43.3417 76 45 76C46.6583 76 48 74.6583 48 73C48 71.3417 46.6583 70 45 70C43.3417 70 42 71.3417 42 73Z" fill="#E6F5F7"/>
            <path d="M42 59C42 60.6529 43.3417 62 45 62C46.6583 62 48 60.6583 48 59C48 57.3417 46.6583 56 45 56C43.3417 56 42 57.3417 42 59Z" fill="#E6F5F7"/>
            <path d="M42 45C42 46.6529 43.3417 48 45 48C46.6583 48 48 46.6583 48 45C48 43.3417 46.6583 42 45 42C43.3417 42 42 43.3417 42 45Z" fill="#E6F5F7"/>
            <path d="M42 31C42 32.6529 43.3417 34 45 34C46.6583 34 48 32.6583 48 31C48 29.3417 46.6583 28 45 28C43.3417 28 42 29.3417 42 31Z" fill="#E6F5F7"/>
            <path d="M42 17C42 18.6529 43.3417 20 45 20C46.6583 20 48 18.6583 48 17C48 15.3417 46.6583 14 45 14C43.3417 14 42 15.3417 42 17Z" fill="#E6F5F7"/>
            <path d="M42 2.99997C42 4.65291 43.3417 6 45 6C46.6583 6 48 4.65828 48 2.99997C48 1.34166 46.6583 -5.86466e-08 45 -1.31134e-07C43.3417 -2.03621e-07 42 1.34166 42 2.99997Z" fill="#E6F5F7"/>
            <path d="M28 101C28 102.653 29.3417 104 31 104C32.6583 104 34 102.658 34 101C34 99.3417 32.6583 98 31 98C29.3417 98 28 99.3417 28 101Z" fill="#E6F5F7"/>
            <path d="M28 87C28 88.6529 29.3417 90 31 90C32.6583 90 34 88.6583 34 87C34 85.3417 32.6583 84 31 84C29.3417 84 28 85.3417 28 87Z" fill="#E6F5F7"/>
            <path d="M28 73C28 74.6529 29.3417 76 31 76C32.6583 76 34 74.6583 34 73C34 71.3417 32.6583 70 31 70C29.3417 70 28 71.3417 28 73Z" fill="#E6F5F7"/>
            <path d="M28 59C28 60.6529 29.3417 62 31 62C32.6583 62 34 60.6583 34 59C34 57.3417 32.6583 56 31 56C29.3417 56 28 57.3417 28 59Z" fill="#E6F5F7"/>
            <path d="M28 45C28 46.6529 29.3417 48 31 48C32.6583 48 34 46.6583 34 45C34 43.3417 32.6583 42 31 42C29.3417 42 28 43.3417 28 45Z" fill="#E6F5F7"/>
            <path d="M28 31C28 32.6529 29.3417 34 31 34C32.6583 34 34 32.6583 34 31C34 29.3417 32.6583 28 31 28C29.3417 28 28 29.3417 28 31Z" fill="#E6F5F7"/>
            <path d="M28 17C28 18.6529 29.3417 20 31 20C32.6583 20 34 18.6583 34 17C34 15.3417 32.6583 14 31 14C29.3417 14 28 15.3417 28 17Z" fill="#E6F5F7"/>
            <path d="M28 2.99997C28 4.65291 29.3417 6 31 6C32.6583 6 34 4.65828 34 2.99997C34 1.34166 32.6583 -5.86466e-08 31 -1.31134e-07C29.3417 -2.03621e-07 28 1.34166 28 2.99997Z" fill="#E6F5F7"/>
            <path d="M14 101C14 102.653 15.3417 104 17 104C18.6583 104 20 102.658 20 101C20 99.3417 18.6583 98 17 98C15.3417 98 14 99.3417 14 101Z" fill="#E6F5F7"/>
            <path d="M14 87C14 88.6529 15.3417 90 17 90C18.6583 90 20 88.6583 20 87C20 85.3417 18.6583 84 17 84C15.3417 84 14 85.3417 14 87Z" fill="#E6F5F7"/>
            <path d="M14 73C14 74.6529 15.3417 76 17 76C18.6583 76 20 74.6583 20 73C20 71.3417 18.6583 70 17 70C15.3417 70 14 71.3417 14 73Z" fill="#E6F5F7"/>
            <path d="M14 59C14 60.6529 15.3417 62 17 62C18.6583 62 20 60.6583 20 59C20 57.3417 18.6583 56 17 56C15.3417 56 14 57.3417 14 59Z" fill="#E6F5F7"/>
            <path d="M14 45C14 46.6529 15.3417 48 17 48C18.6583 48 20 46.6583 20 45C20 43.3417 18.6583 42 17 42C15.3417 42 14 43.3417 14 45Z" fill="#E6F5F7"/>
            <path d="M14 31C14 32.6529 15.3417 34 17 34C18.6583 34 20 32.6583 20 31C20 29.3417 18.6583 28 17 28C15.3417 28 14 29.3417 14 31Z" fill="#E6F5F7"/>
            <path d="M14 17C14 18.6529 15.3417 20 17 20C18.6583 20 20 18.6583 20 17C20 15.3417 18.6583 14 17 14C15.3417 14 14 15.3417 14 17Z" fill="#E6F5F7"/>
            <path d="M14 2.99997C14 4.65291 15.3417 6 17 6C18.6583 6 20 4.65828 20 2.99997C20 1.34166 18.6583 -5.86466e-08 17 -1.31134e-07C15.3417 -2.03621e-07 14 1.34166 14 2.99997Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 101C-2.03385e-07 102.653 1.34169 104 3.00001 104C4.65832 104 6 102.658 6 101C6 99.3417 4.65832 98 3.00001 98C1.34169 98 -5.86457e-08 99.3417 -1.31133e-07 101Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 87C-2.03385e-07 88.6529 1.34169 90 3.00001 90C4.65832 90 6 88.6583 6 87C6 85.3417 4.65832 84 3.00001 84C1.34169 84 -5.86457e-08 85.3417 -1.31133e-07 87Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 73C-2.03385e-07 74.6529 1.34169 76 3.00001 76C4.65832 76 6 74.6583 6 73C6 71.3417 4.65832 70 3.00001 70C1.34169 70 -5.86457e-08 71.3417 -1.31133e-07 73Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 59C-2.03385e-07 60.6529 1.34169 62 3.00001 62C4.65832 62 6 60.6583 6 59C6 57.3417 4.65832 56 3.00001 56C1.34169 56 -5.86457e-08 57.3417 -1.31133e-07 59Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 45C-2.03385e-07 46.6529 1.34169 48 3.00001 48C4.65832 48 6 46.6583 6 45C6 43.3417 4.65832 42 3.00001 42C1.34169 42 -5.86457e-08 43.3417 -1.31133e-07 45Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 31C-2.03385e-07 32.6529 1.34169 34 3.00001 34C4.65832 34 6 32.6583 6 31C6 29.3417 4.65832 28 3.00001 28C1.34169 28 -5.86457e-08 29.3417 -1.31133e-07 31Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 17C-2.03385e-07 18.6529 1.34169 20 3.00001 20C4.65832 20 6 18.6583 6 17C6 15.3417 4.65832 14 3.00001 14C1.34169 14 -5.86457e-08 15.3417 -1.31133e-07 17Z" fill="#E6F5F7"/>
            <path d="M-1.31133e-07 2.99997C-2.03385e-07 4.65291 1.34169 6 3.00001 6C4.65832 6 6 4.65828 6 2.99997C6 1.34166 4.65832 -5.86466e-08 3.00001 -1.31134e-07C1.34169 -2.03621e-07 -5.86457e-08 1.34166 -1.31133e-07 2.99997Z" fill="#E6F5F7"/>
          </svg>
        </div>
        <div class="content-text-wrapper" style="margin-top: -10rem;">
          <p class="eyebrow">RESEARCH CAPACITY AND COLLABORATION</p>
          <h2>Strengthening health research <br> capacity in Africa</h2>
          <div class="text-content">
            <p>EDCTP supports four Regional Networks of Excellence, in Central, East, Southern and Western Africa, to strengthen regional networking and to provide platforms for research training and multicentre studies. The Networks offer several learning and collaboration opportunities through trainings, workshops and other resource materials.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="networks" class="networks-section" style="height: 300px">
    <div class="container" style="margin-top: -300px">
      <div class="row">
        <div class="col-md-3 mb-4">
          <div class="network-card">
            <img src="/f59e77b2387e5ea09884dba3b5b2d7a8b130ddbe.png" alt="CANTAM Logo" class="card-logo">
            <p class="card-description">In Central Africa, the Central African Network on TB, HIV/AIDS and malaria (CANTAM) joins institutions involved in clinical trials. The Network started its activities on 19 December 2008.</p>
            <a @click.prevent="openModal(1)" class="card-link">More info <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
              <path d="M2 2L5 5L2 8" stroke="#009CAD" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></a>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="network-card">
            <img src="/ef2e00d8191b6c1764ef28e55ae2b4647be55ff0.png" alt="WANETAM Logo" class="card-logo">
            <p class="card-description">The West African Network on TB, AIDS and Malaria (WANETAM) builds capacity to prepare West African sites for clinical trials on HIV, TB and malaria. The network started its activities on 31 July 2009.</p>
            <a @click.prevent="openModal(2)" class="card-link">More info <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
              <path d="M2 2L5 5L2 8" stroke="#009CAD" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></a>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="network-card">
            <img src="/9849c5b04e343f250e6823c2b762598793984c8e.png" alt="EACCR Logo" class="card-logo">
            <p class="card-description">The East African Consortium for Clinical Research (EACCR) coordinates clinical research activities across East Africa, focusing on capacity building and collaborative research initiatives.</p>
            <a @click.prevent="openModal(3)" class="card-link">More info <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
              <path d="M2 2L5 5L2 8" stroke="#009CAD" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></a>
          </div>
        </div>
        <div class="col-md-3 mb-4">
          <div class="network-card">
            <img src="/29f2e91070939608d8928a196071004c7a5f466e.png" alt="TESA Logo" class="card-logo">
            <p class="card-description">Trials of Excellence in Southern Africa (TESA) promotes clinical research excellence and capacity building throughout the Southern African region.</p>
            <a @click.prevent="openModal(4)" class="card-link">More info <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
              <path d="M2 2L5 5L2 8" stroke="#009CAD" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg></a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div v-if="showModal && selectedNetwork" class="modal-overlay" @click="closeModal">
    <div class="network-modal" @click.stop>

      <div class="modal-top">
        <img :src="selectedNetwork.logo" class="modal-logo" />
        <button class="close-btn" @click="closeModal">×</button>
      </div>

      <img :src="selectedNetwork.image" class="modal-image" style="width: 549px; height: 308px;" />

      <div class="modal-content">
        <p v-html="selectedNetwork.content"></p>

        <div class="modal-links">
          <a :href="selectedNetwork.website" target="_blank">🌐 Website: {{ selectedNetwork.website }}</a>
          <br>
          <a v-if="selectedNetwork.extraLink" :href="selectedNetwork.extraLink" target="_blank">
            👉 Additional Link
          </a>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
export default {
  name: 'Network',

  data() {
    return {
      showModal: false,
      selectedNetwork: null,
      networks: [],
      networksContent: [
        {
          id: 1,
          title: "CANTAM",
          logo: "/f59e77b2387e5ea09884dba3b5b2d7a8b130ddbe.png",
          image: "/phpw9N59X.jpeg",
          website: "https://www.cantam.net",
          content: `
      In Central Africa, the Central African Network on TB, HIV/AIDS and malaria (CANTAM) joins institutions involved in clinical trials.
      The Network started its activities on <strong>19 December 2008</strong>.
      <br><br>
      The COVID-19 pandemic exposed deficiencies in African health systems, underscoring the demand for skilled female Ph.D. scientists in clinical research.
      In 2020, CANTAM, with support from EDCTP, initiated the ‘Women in Science’ female Ph.D. fellowship program. This program aims to address discipline gaps in the Central region by supporting female Ph.Ds and MScs in health sciences while enhancing mentorship opportunities for women scientists in Central Africa.
    `,
          extraLink: "https://cantam.net/en/wise-alumini/"
        },

        {
          id: 2,
          title: "WANETAM",
          logo: "/ef2e00d8191b6c1764ef28e55ae2b4647be55ff0.png",
          image: "/php3c8d9X.jpeg",
          website: "https://www.wanetam.org",
          content: `
      The West African Network on TB, AIDS and Malaria (WANETAM) builds capacity to prepare West African sites for clinical trials on HIV, TB and malaria.
      The network started its activities on <strong>31 July 2009</strong>.
      <br><br>
      In 2020, with support from EDCTP, WANETAM established a gender-sensitive capacity-building platform for clinical research in West Africa —
      the <strong>TALENT Fellowship Program</strong>. The initiative aims to empower world-class, technically competent, and multidisciplinary women scientists.
      The goal is to advance research on emerging and endemic infectious diseases including Tuberculosis, AIDS, malaria, and COVID-19 in Sub-Saharan Africa.
    `,
          extraLink: "https://thetalentfellowship.org/"
        },

        {
          id: 3,
          title: "EACCR",
          logo: "/9849c5b04e343f250e6823c2b762598793984c8e.png",
          image: "/phpk2r2Bz.jpeg",
          website: "https://www.eaccr.org",
          content: `
      The East African Consortium for Clinical Research (EACCR) strengthens clinical trial sites in Eastern Africa.
      The Network started on <strong>14 May 2009</strong>.
      <br><br>
      The <strong>Capacity Building for Female Scientists in East Africa (CAFÉ-SEA)</strong> fellowship programme, supported by EDCTP, operates within EACCR.
      The programme addresses the under-representation of women in infectious disease research in Eastern Africa.
      Recognising the challenges faced by women in academic science careers, CAFÉ-SEA strengthens research capacity through multidisciplinary PhD training and mentorship —
      crucial for addressing regional epidemics such as Ebola and COVID-19.
    `,
          extraLink: "https://www.eaccr.org/cafe-sea"
        },

        {
          id: 4,
          title: "TESA",
          logo: "/29f2e91070939608d8928a196071004c7a5f466e.png",
          image: "/phpNkP5fN.jpeg",
          website: "https://tesanetwork.org/tesa-homepage/",
          content: `
      The Trials of Excellence in Southern Africa (TESA) is a regional network established in <strong>2009</strong> under the first programme of the European and Developing Countries Clinical Trials Partnership (EDCTP1).
      The objective is to create a framework for collaboration, capacity building, and training among institutions across the Southern African region.
      <br><br>
      Under EDCTP2, the network expanded to fifteen institutions across eight Southern African countries and four European countries.
      <br><br>
      TESA also addresses gender equity in research capacity through the <strong>TAGENDI Fellowship Programme</strong>, supporting women scientists to address the gender gap in clinical research across the region.
    `,
          extraLink: "https://tesanetwork.org/tagendi/"
        }
      ],
    }
  },

  mounted() {
    const idFromQuery = this.$route.query.open;
    if (idFromQuery) {
      this.openModal(Number(idFromQuery));
    }
  },

  computed: {

  },

  watch: {
    '$route.query.open': {
      immediate: true,
      handler(value) {
        if (value) {
          this.openModal(parseInt(value));
        }
      }
    }
  },

  methods: {
    openModal(id) {
      const network = this.networksContent.find(n => n.id === id);

      if (!network) {
        console.error("Network not found:", id);
        return;
      }

      this.selectedNetwork = network;
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.$router.push({ query: {} });
    },
  }
}
</script>

<style scoped>

.network-card {
  border-radius: 16px;
  background: #FFF;
  box-shadow: 0px 4px 50px 0px rgba(37, 81, 83, 0.15);
  text-align: center;
  padding: 2rem;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-logo {
  max-width: 100%;
  height: auto;
  margin-bottom: 1rem;
}

.card-description {
  flex-grow: 1;
  margin-bottom: 1.5rem;
}

.card-link {
  margin-top: auto;
}
/* CSS from section:hero */
.hero-section {
  position: relative;
  height: 207px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: var(--color-primary);
  text-align: center;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('/public/33ad975811d706b6ec2e9ccd50aca96d7ac62133.png');
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.hero-section::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 156, 173, 0.7); /* Even lighter */
  z-index: 2;
}

.hero-content {
  position: relative;
  z-index: 10 !important; /* Ensures text is above both background and overlay */
}

.hero-content {
  position: relative;
  z-index: 1;
  padding: 0 20px;
  color: #fff;
}

.hero-content h1 {
  font-size: 64px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.64px;
}

@media (max-width: 768px) {
  .hero-content h1 {
    font-size: 40px;
  }
}

/* CSS from section:main-content */
.main-content-section {
  padding: 120px 0;
}

.content-grid {
  display: flex;
  align-items: center;
  gap: 90px;
}

.content-image-wrapper {
  flex: 0 0 547px;
  position: relative;
}

.image-stack {
  position: relative;
  width: 547px;
  height: 526px;
  border-radius: 16px;
  overflow: hidden;
}

.image-stack .main-image,
.image-stack .secondary-image {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.decorative-svg {
  position: absolute;
  left: -140px;
  top: 150px;
  width: 174px;
  height: 160px;
  transform: rotate(90deg);
  z-index: -1;
}

.content-text-wrapper {
  flex: 1;
}

.eyebrow {
  color: var(--color-secondary);
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.2px;
  margin-bottom: 40px;
}

.content-text-wrapper h2 {
  color: var(--color-primary);
  font-size: 52px;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 48px;
}

.text-content {
  display: flex;
  flex-direction: column;
  gap: 26px;
  font-size: 20px;
  line-height: 1.3;
  letter-spacing: -0.4px;
}

@media (max-width: 1024px) {
  .content-grid {
    flex-direction: column;
    gap: 60px;
  }
  .content-image-wrapper {
    flex: 0 0 auto;
    width: 100%;
    max-width: 547px;
  }
  .image-stack {
    width: 100%;
    height: auto;
    padding-top: 96%; /* Aspect ratio 526/547 */
  }
  .decorative-svg {
    display: none;
  }
}

@media (max-width: 768px) {
  .main-content-section {
    padding: 60px 0;
  }
  .eyebrow {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .content-text-wrapper h2 {
    font-size: 36px;
    margin-bottom: 24px;
  }
  .text-content {
    font-size: 18px;
  }
}

/* CSS from section:networks */
.networks-section {
  padding: 120px 0;
  background-color: var(--color-secondary);
  background-image: url('');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.networks-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
}

.network-card {
  background-color: #fff;
  color: #000;
  border-radius: 16px;
  box-shadow: 0px 4px 50px 0px rgba(37, 81, 83, 0.15);
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  padding-bottom: 70px; /* space for the link */
}

.card-logo {
  height: 111px;
  object-fit: contain;
  margin-bottom: 24px;
}

.card-description {
  font-size: 16px;
  line-height: 1.25;
  letter-spacing: -0.32px;
  flex-grow: 1;
}

.card-link {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  color: var(--color-primary);
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 24px;
  width: calc(100% - 48px);
  justify-content: center;
}

.card-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #d8dbdb;
}

.card-link img {
  width: 3px;
  height: 6px;
}

@media (max-width: 1200px) {
  .networks-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .networks-section {
    padding: 60px 0;
  }
  .networks-grid {
    grid-template-columns: 1fr;
  }
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  z-index: 9999;
}

.network-modal {
  background: white;
  border-radius: 18px;
  width: 80%;
  max-width: 1050px;
  max-height: 90vh;
  overflow-y: auto;     /* 👈 entire modal scrolls */
  padding: 20px;
  box-shadow: 0px 6px 40px rgba(0,0,0,0.2);
  animation: fadeIn 0.3s ease;
  position: relative;
}

/* Remove scrolling rules from content */
.modal-content {
  margin-top: 20px;
}


.modal-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-logo {
  width: 200px;
  object-fit: contain;
}

.close-btn {
  border: none;
  background: transparent;
  font-size: 34px;
  cursor: pointer;
  color: #333;
}

.modal-image {
  width: 100%;
  border-radius: 14px;
  margin-top: 15px;
  object-fit: cover;
  margin: 15px auto;
  display: block;
}

.modal-content p {
  line-height: 1.6;
  font-size: 17px;
}

.modal-links {
  margin-top: 20px;
}

.modal-links a {
  display: inline-block;
  color: #009CAD;
  font-weight: bold;
  text-decoration: none;
}

.modal-links a:hover {
  text-decoration: underline;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .modal-logo {
    width: 140px;
  }

  .network-modal {
    width: 95%;
    padding: 15px;
  }

  .modal-content {
    max-height: calc(90vh - 300px);
  }
}


</style>
